module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Black.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Black.eot
 ** module id = 348
 ** module chunks = 0
 **/